// extracted by mini-css-extract-plugin
module.exports = {"card-border-gray":"#d9d9d9","warning-red":"#d50000","container":"RoundCard-module__container___32-V9","checked":"RoundCard-module__checked____pDs1"};